import APIconsume from 'Main/APIconsume'

const BASE_URL = '/api/dashboard/qris-ext-configs'

class QrisExtConfigsService {
  constructor () {
    this._apiConsume = new APIconsume()
  }

  /** GET /vendors/qris-ext-configs */
  async getData () {
    const result = await this._apiConsume.getData(BASE_URL)
    return result?.data
  }

  /** GET /vendors/qris-ext-configs/:id: used by the Edit flow (viewQrisConfig in the ejs). */
  async getById (id) {
    const result = await this._apiConsume.getData(`${BASE_URL}/${id}`)
    return result?.data
  }

  /** POST /vendors/qris-ext-configs */
  async create (payload) {
    const result = await this._apiConsume.postData(payload, BASE_URL)
    return result?.data
  }

  /** PUT /vendors/qris-ext-configs/:id */
  async update (id, payload) {
    const result = await this._apiConsume.putData(payload, `${BASE_URL}/${id}`)
    return result?.data
  }

  /** DELETE /vendors/qris-ext-configs/:id */
  async deleteById (id) {
    const result = await this._apiConsume.deleteData(`${BASE_URL}/${id}`)
    return result?.data
  }

  /**
   * GET /vendors/payment-vendors: replaces the ejs's controller-injected
   * `paymentVendors` local.
   */
  async getPaymentVendors () {
    const result = await this._apiConsume.getData('/api/dashboard/payment-vendors')
    return result?.data
  }
}

export default QrisExtConfigsService
